import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

// Layouts
import Layout1 from '@/layout/Layout1'
import { Yetki } from '@/utils/enums'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/giris',
      name: 'OturumAc',
      component: () => import('@/views/auth/login')
    },
    {
      path: '/kayit',
      name: 'Kayit',
      component: () => import('@/views/auth/kayit')
    },
    {
      path: '/yuzyuze-egitim-kayit',
      name: 'YuzyuzeKayit',
      component: () => import('@/views/auth/yuzyuze-kayit')
    },
    {
      path: '/uzaktan-egitim-kayit',
      name: 'UzaktanKayit',
      component: () => import('@/views/auth/uzaktan-kayit')
    },
    {
      path: '/medreseli-kayit',
      name: 'MedreseliKayit',
      component: () => import('@/views/auth/medreseli-kayit')
    },
    {
      path: '/parola-sifirla',
      name: 'ParolaSifirla',
      component: () => import('@/views/auth/sifremiUnuttum')
    },
    {
      path: '/',
      redirect: '/anasayfa',
      component: Layout1,
      children: [{
        path: 'anasayfa',
        component: () => import('@/views/home'),
        name: 'AnaSayfa'
      }, {
        path: 'kisi/liste',
        name: 'KisiListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/kisi')
      }, {
        path: 'kisi/sertifika',
        name: 'SertifikaGonderimListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/sertifika-gonder')
      }, {
        path: 'rapor',
        name: 'Rapor',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/rapor')
      }, {
        path: 'ogrenci/liste',
        name: 'OgrenciListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/ogrenci')
      }, {
        path: 'ogrenci/excel-ekleme',
        name: 'OgrenciExcelEkleme',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/ogrenciExcelOkuma')
      }, {
        path: 'medreseli-talebe/liste',
        name: 'MedreseliTalebeListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/medrese-talebe')
      }, {
        path: 'sinif/liste',
        name: 'SinifListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sinif')
      }, {
        path: 'sinif/ogrenci/:id',
        name: 'SinifOgrenciListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sinifOgrenci')
      }, {
        path: 'sinif/ders/:id',
        name: 'SinifDersListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sinifDers')
      }, {
        path: 'sinif/yoklama/:id',
        name: 'SinifYoklamaListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sinifYoklama')
      }, {
        path: 'sinif/otomatik-ders/:id',
        name: 'SinifOtomatikDersListesi',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/sinifOtomatikDers')
      }, {
        path: 'baslayacak-devam-edenler',
        name: 'BaslayacakDevamEdenler',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/baslayacakDevamEdenler')
      }, {
        path: 'dosyalar',
        name: 'Dosyalar',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/dosya')
      }, {
        path: 'odevler',
        name: 'Odevler',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA, Yetki.TALEBE]
        }],
        component: () => import('@/views/odev')
      }, {
        path: 'etkinlikler',
        name: 'Etkinlikler',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/etkinlik')
      }, {
        path: 'yuzyuze-egitim-yerler',
        name: 'YuzyuzeEgitimYerler',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/yuzyuzeEgitimYerler')
      }, {
        path: 'okullar',
        name: 'Okullar',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/okul')
      }, {
        path: 'temizlik-gorevlisi-icin-okullar',
        name: 'MebOkullar',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/mebOkul')
      }, {
        path: 'seanslar',
        name: 'Seanslar',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/seans')
      }, {
        path: 'inayet-tasarruf',
        name: 'InayetTasarruf',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/inayetTasarruf')
      }, {
        path: 'raporlarim',
        name: 'Raporlarim',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/raporlarim')
      }, {
        path: 'iletisim-bilgileri',
        name: 'iletisim-bilgileri',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/iletisimBilgileri')
      }, {
        path: 'profilim',
        name: 'Profil',
        meta: [{
          Roles: [Yetki.TALEBE]
        }],
        component: () => import('@/views/profil')
      }, {
        path: 'seminer/:id?',
        name: 'seminer',
        component: () => import('@/views/seminer')
      }, {
        path: 'seminerler',
        name: 'seminerler',
        component: () => import('@/views/seminerler')
      }, {
        path: 'iletisim',
        name: 'iletisim',
        meta: [{
          Roles: [Yetki.TALEBE]
        }],
        component: () => import('@/views/iletisim')
      }, {
        path: 'toplu-sertifika',
        name: 'toplu-sertifika',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/TopluSertifika')
      }, {
        path: 'toplu-sms',
        name: 'TopluSMS',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE]
        }],
        component: () => import('@/views/TopluSMS')
      }, {
        path: 'hocasi-olmayan-siniflar',
        name: 'hocasi-olmayan-siniflar',
        meta: [{
          Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
        }],
        component: () => import('@/views/hocasi-olmayan-siniflar.vue')
      }]
    }, {
      path: '*',
      component: NotFound
    }]
})

// Yeni sürüm yayına çıktığında eski build'in parça (chunk) dosyaları silinir.
// Tarayıcıda eski index.html/app.js kalmışsa artık var olmayan bir parçayı
// ister, 404 alır ve sayfa hiç açılmaz — kullanıcıya "hiçbir şey olmuyor"
// gibi görünür. Böyle bir durumda sayfayı bir kez yenilemek yeterli: yeni
// index.html alınır ve doğru parçalar yüklenir.
// Sonsuz döngüye girmemek için tek denemeyle sınırlanır.
const PARCA_YENILEME_ANAHTARI = 'parca-yukleme-yenilendi'
router.onError(error => {
  const mesaj = (error && error.message) || ''
  const parcaHatasi = /Loading chunk|ChunkLoadError|Loading CSS chunk/i.test(mesaj)
  if (!parcaHatasi) return
  if (sessionStorage.getItem(PARCA_YENILEME_ANAHTARI)) return
  sessionStorage.setItem(PARCA_YENILEME_ANAHTARI, '1')
  window.location.reload(true)
})
router.afterEach(() => sessionStorage.removeItem(PARCA_YENILEME_ANAHTARI))

export default router
